import { Link } from 'react-router-dom';

const footerLinks = {
  services: {
    title: '服务分类',
    links: [
      { label: '深夜咨询', path: '/categories' },
      { label: '凌晨配送', path: '/categories' },
      { label: '紧急支援', path: '/categories' },
      { label: '生活服务', path: '/categories' },
      { label: '健康守护', path: '/categories' },
    ],
  },
  company: {
    title: '关于我们',
    links: [
      { label: '品牌故事', path: '/about' },
      { label: '口碑声誉', path: '/about#reputation' },
      { label: '联系我们', path: '/about#contact' },
      { label: '最新资讯', path: '/articles' },
    ],
  },
  support: {
    title: '帮助支持',
    links: [
      { label: '常见问题', path: '/about#faq' },
      { label: '服务保障', path: '/about#guarantee' },
      { label: '用户协议', path: '/' },
      { label: '隐私政策', path: '/' },
    ],
  },
};

export default function Footer() {
  return (
    <footer className="bg-background-900 text-white">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="text-xl font-heading font-bold whitespace-nowrap cursor-pointer">
                凌晨不打烊
              </Link>
              <p className="mt-4 text-sm text-background-300 leading-relaxed">
                24小时全天候服务平台，深夜下单、凌晨咨询、随时响应。无论几点都有人在线守候，用心陪伴每一位用户。
              </p>
              <div className="flex items-center gap-3 mt-5">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-700 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-700 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-700 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="小红书">
                  <i className="ri-reddit-line text-sm"></i>
                </a>
              </div>
            </div>

            {Object.entries(footerLinks).map(([key, section]) => (
              <div key={key}>
                <h4 className="text-sm font-semibold mb-4 text-background-100">{section.title}</h4>
                <ul className="space-y-2.5">
                  {section.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.path}
                        className="text-sm text-background-300 hover:text-white transition-colors cursor-pointer"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-12 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-background-400">
              &copy; 2026 凌晨不打烊 版权所有 | 24小时服务热线：400-888-0000
            </p>
            <div className="flex items-center gap-6">
              <Link to="/" className="text-sm text-background-400 hover:text-white transition-colors cursor-pointer">用户协议</Link>
              <Link to="/" className="text-sm text-background-400 hover:text-white transition-colors cursor-pointer">隐私政策</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}